import React from 'react';

import { AllFilters as AllFiltersProvider } from 'components/Filters';

import { Grid } from '@gogame/components';

import * as Filters from './filters';

const AllFilters = ({ open, onClose, onExited }) => (
  <AllFiltersProvider open={open} onClose={onClose} onExited={onExited}>
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <Filters.Statuses />
      </Grid>
      <Grid item xs={4}>
        <Filters.PartnerCompanies withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.BusinessPartners withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.Networks withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.Applications withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.Platforms withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.Clusters withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.TrafficTypes withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.ExpenseTypes withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.Owners withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.CreatedBy withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.ChannelType withFavoriteActions={true} />
      </Grid>
      <Grid item xs={4}>
        <Filters.Channels withFavoriteActions={true} />
      </Grid>
    </Grid>
  </AllFiltersProvider>
);

export default AllFilters;
